import React, { useState } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { CheckCircle, RadioButtonUnchecked } from "@mui/icons-material";
import ModalComponent from "../../../Modals";
import { EntranceConfigContainer } from "./styles";
import { INVITATION_ENTRANCE, Invitations } from "../../../../store/services/invitations/dto/invitations.dto";
import { InvitationColorMatrix } from "../../../../InvitationColorMatrix";

import {
	CurtainEntrance,
	EnvelopeEntrance,
	NamesEntrance,
	PalaceDoorsEntrance,
	RingsEntrance
} from "../../../../Pages/Templates/WeddingInvitationTemplates/InvitationEntrances";

interface EntranceConfigProps {
	onClose: () => void;
	handleSelectEntrance: (id: INVITATION_ENTRANCE) => void;
	managedInvitation: Invitations;
}

const noop = () => {};

const EntranceConfig = ({ onClose, managedInvitation, handleSelectEntrance }: EntranceConfigProps) => {
	const theme = useTheme();
	const isSmallerScreen = useMediaQuery(theme.breakpoints.down("md"));
	const [selectedEntrance, setSelectedEntrance] = useState<INVITATION_ENTRANCE>(
		managedInvitation?.entrance ?? INVITATION_ENTRANCE.NAMES
	);

	const colorMatrix =
		InvitationColorMatrix[managedInvitation?.template_id || 1][managedInvitation?.template_color || 1];

	const entrances = [
		{
			id: INVITATION_ENTRANCE.NAMES,
			label: "Names",
			preview: (
				<NamesEntrance
					preview={true}
					isOpened={false}
					setIsOpened={noop}
					selectedInvitation={managedInvitation}
					colorMatrix={colorMatrix}
				/>
			)
		},
		{
			id: INVITATION_ENTRANCE.ENVELOPE,
			label: "Envelope",
			preview: (
				<EnvelopeEntrance
					preview={true}
					openEnvelope={false}
					setOpenEnvelope={noop}
					selectedInvitation={managedInvitation}
					colorMatrix={colorMatrix}
				/>
			)
		},
		{
			id: INVITATION_ENTRANCE.RINGS,
			label: "Rings",
			preview: (
				<RingsEntrance
					preview={true}
					isOpened={false}
					setIsOpened={noop}
					selectedInvitation={managedInvitation}
					colorMatrix={colorMatrix}
				/>
			)
		},
		{
			id: INVITATION_ENTRANCE.CURTAIN,
			label: "Curtain",
			preview: (
				<CurtainEntrance
					preview={true}
					isOpened={false}
					setIsOpened={noop}
					selectedInvitation={managedInvitation}
					colorMatrix={colorMatrix}
				/>
			)
		},
		{
			id: INVITATION_ENTRANCE.PALACE_DOORS,
			label: "Palace doors",
			preview: (
				<PalaceDoorsEntrance
					preview={true}
					isOpened={false}
					setIsOpened={noop}
					selectedInvitation={managedInvitation}
					colorMatrix={colorMatrix}
				/>
			)
		}
	];

	return (
		<ModalComponent open={true} handleCloseModal={onClose} width={isSmallerScreen ? "95%" : "700px"}>
			<Typography variant={"h6"}>Choose Entrance</Typography>
			<EntranceConfigContainer>
				{entrances.map(entrance => (
					<Box
						className={`entrance_card ${selectedEntrance === entrance.id ? "selected" : ""}`}
						key={entrance.id}
						onClick={() => {
							if (entrance.id === selectedEntrance) return;
							setSelectedEntrance(entrance.id);
							handleSelectEntrance(entrance.id);
						}}
					>
						<Box className={`preview_frame ${entrance.id === INVITATION_ENTRANCE.ENVELOPE ? "envelope" : ""}`}>
							{entrance.preview}
						</Box>
						<Box className={"entrance_footer"}>
							<Typography className={"label"}>{entrance.label}</Typography>
							{selectedEntrance === entrance.id ? (
								<CheckCircle className={"check"} />
							) : (
								<RadioButtonUnchecked className={"check"} />
							)}
						</Box>
					</Box>
				))}
			</EntranceConfigContainer>
		</ModalComponent>
	);
};

export default EntranceConfig;
